import styles from './Alert.module.css';
import { AlertData } from '../model/AlertData';
import classNames from 'classnames/bind';
import { AiOutlineInfoCircle, AiOutlineCheckCircle } from 'react-icons/ai';
import { HiOutlineExclamationTriangle, HiOutlineExclamationCircle } from 'react-icons/hi2';

const cx = classNames.bind(styles);

export default function Alert({ alertType, content }: AlertData) {
  function setAlertStyles() {
    let classNameArray = [];

    classNameArray.push('alert-container');

    switch (alertType) {
      case 'warning':
        classNameArray.push('warning');
        break;
      case 'danger':
        classNameArray.push('danger');
        break;
      case 'info':
        classNameArray.push('info');
        break;
      default:
        classNameArray.push('success');
    }

    return classNameArray;
  }

  const alertContainerClasses = cx(setAlertStyles());

  function getAlertIcon() {
    switch (alertType) {
      case 'warning':
        return <HiOutlineExclamationTriangle />;
      case 'danger':
        return <HiOutlineExclamationCircle />;
      case 'info':
        return <AiOutlineInfoCircle />;
      default:
        return <AiOutlineCheckCircle />;
    }
  }

  return (
    <div data-testid="alert-modal" className={alertContainerClasses}>
      <span data-testid="alert-icon" className={styles.alert_icon}>
        {getAlertIcon()}
      </span>
      <span data-testid="alert-content">{content}</span>
    </div>
  );
}
